import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Truck, Clock, Shield, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const ShippingInfo = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Home
              </Button>
            </Link>
            <h1 className="text-xl font-bold">Shipping Information</h1>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Shipping Options */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Truck className="h-5 w-5" />
                Shipping Options
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Standard Shipping</h3>
                <p className="text-sm text-muted-foreground mb-2">
                  7-14 business days
                </p>
                <p className="text-sm">$15.00</p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Express Shipping</h3>
                <p className="text-sm text-muted-foreground mb-2">
                  3-5 business days
                </p>
                <p className="text-sm">$25.00</p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Overnight Shipping</h3>
                <p className="text-sm text-muted-foreground mb-2">
                  Next business day
                </p>
                <p className="text-sm">$45.00</p>
              </div>
            </CardContent>
          </Card>

          {/* Processing Times */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Clock className="h-5 w-5" />
                Processing Times
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Standard Orders</h3>
                <p className="text-sm text-muted-foreground">
                  2-3 business days to process and prepare for shipping
                </p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Custom Designs</h3>
                <p className="text-sm text-muted-foreground">
                  3-5 business days for custom design approval and production
                </p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold mb-2">Bulk Orders</h3>
                <p className="text-sm text-muted-foreground">
                  5-7 business days for orders of 10 or more items
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Shipping Areas */}
        <Card className="mt-8">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <MapPin className="h-5 w-5" />
              Shipping Areas
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold mb-3">Domestic Shipping</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>• All regions within Ghana</li>
                  <li>• Free shipping on orders over $100</li>
                  <li>• Tracking included with all orders</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-3">International Shipping</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>• Available to select countries</li>
                  <li>• Additional customs fees may apply</li>
                  <li>• Delivery times may vary</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Contact Support */}
        <Card className="mt-8">
          <CardContent className="pt-6 text-center">
            <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
            <h3 className="text-lg font-semibold mb-2">
              Need Help with Shipping?
            </h3>
            <p className="text-muted-foreground mb-4">
              Our support team is here to help with any shipping questions
            </p>
            <Button>
              <MessageCircle className="h-4 w-4 mr-2" />
              Contact Support
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ShippingInfo;
